import { ProductCategory } from 'modules/product/definitions/applications/entities/product-category.entity';
import omit from 'lodash/omit';
import { DocumentReviewConclusion } from './document-review-conclusion.entity';
import { DocumentReviewProduct } from './document-review-product.entity';

class CompanyLogo {
  constructor(data) {
    Object.assign(this, data);
  }
}

class Area {
  constructor(data) {
    Object.assign(this, data);
  }
}

class Supplier {
  constructor(data) {
    Object.assign(this, data);
    if (data.companyLogo) this.companyLogo = new CompanyLogo(data.companyLogo);
    if (data.area) this.area = new Area(data.area);
    this.productSubCategories = (data.productSubCategories || []).map(
      (sub) => new ProductCategory(sub)
    );
  }
}

class Laboratory {
  constructor(data) {
    Object.assign(this, data);
  }
}

export class DocumentReview {
  constructor(data) {
    this.id = data.id;
    this.uploadType = data.uploadType;
    this.jobNo = data.jobNo;
    this.title = data.title;
    this.jobType = data.jobType;
    this.companyId = data.companyId;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.status = data.status;
    this.isTechnicalFileReview = data.isTechnicalFileReview;
    this.isArtWorkReview = data.isArtWorkReview;
    this.isImageReview = data.isImageReview;
    this.isCPCReview = data.isCPCReview;
    this.buyerName = data.buyerName;
    this.serviceLevel = data.serviceLevel;
    this.description = data.description;
    this.isPartnerReview = data.isPartnerReview;
    this.isOwnerReview = data.isOwnerReview;
    this.ecd = data.ecd;
    this.laboratory = data.laboratory ? new Laboratory(data.laboratory) : null;
    this.supplierCompany = data.supplierCompany;
    this.supplier = data.supplier ? new Supplier(data.supplier) : null;
    this.productProfileMaps = (data.productProfileMaps || []).map(
      (map) => new DocumentReviewProduct(map)
    );
    this.desktopReviewConclusion = data.desktopReviewConclusion
      ? new DocumentReviewConclusion(data.desktopReviewConclusion)
      : null;
    this.canReview = data.canReview;
    this.canUploadDocuments = data.canUploadDocuments;
    this.canStartResubmit = data.canStartResubmit;
    this.canEdit = data.canEdit;
    this.isResubmitted = data.isResubmitted;
  }

  static createDocumentReviewByProductEntity(productEntity) {
    const {
      product: productProfileMap,
      supplier,
    } = DocumentReviewProduct.initializeDocumentReviewProduct(productEntity);

    const entity = new DocumentReview({
      productProfileMaps: productProfileMap ? [productProfileMap] : null,
      supplier,
    });

    return omit(entity, ['id']);
  }
}
